import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import {
  IUnavailableRequestsReports,
  IExcelDownloadResponse,
  IFilterUnavailableRequestsReports
} from '../data/unavailable-requests-reports';

@Injectable({
  providedIn: 'root'
})
export class UnavailableRequestsReportsService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}UnavailableRequestsReports`;

  constructor(
    private readonly http: HttpClient,
    protected readonly toast: ToastService
  ) {
    super(toast);
  }

  getUnavailableRequestsReports(
    filter: IFilterUnavailableRequestsReports
  ): Observable<ResponseDefault<IUnavailableRequestsReports[]>> {
    let params = new HttpParams().appendAll({
      pageNumber: filter.pageNumber.toString(),
      pageSize: filter.pageSize.toString()
    });

    if (filter.orderBy) {
      params = params.append('orderBy', filter.orderBy.toString());
    }
    if (filter.companyId) {
      params = params.append('companyId', filter.companyId);
    }
    if (filter.partnerId) {
      params = params.append('partnerId', filter.partnerId);
    }
    if (filter.searchText) {
      params = params.append('searchText', filter.searchText);
    }
    if (filter.selectedDate) {
      params = params.append('selectedDate', filter.selectedDate);
    }
    if (filter.startDate) {
      params = params.append('startDate', filter.startDate);
    }
    if (filter.endDate) {
      params = params.append('endDate', filter.endDate);
    }

    return this.http.get<ResponseDefault<IUnavailableRequestsReports[]>>(
      `${this.apiUrl}/GetUnavailableRequestsReport`,
      { params }
    );
  }

  exportarExcelUnavailableRequestsReports(filters: IFilterUnavailableRequestsReports): void {
    const body: any = {};

    if (filters.companyId) {
      body.companyId = filters.companyId;
    }
    if (filters.searchText) {
      body.searchText = filters.searchText;
    }
    if (filters.selectedDate) {
      body.selectedDate = filters.selectedDate;
    }
    if (filters.startDate) {
      body.startDate = filters.startDate;
    }
    if (filters.endDate) {
      body.endDate = filters.endDate;
    }

    this.http.post<IExcelDownloadResponse>(`${this.apiUrl}/ExportExcel`, body).subscribe((resposta) => {
      saveAs(`data:${resposta.contentType};base64,${resposta.fileContents}`, resposta.fileDownloadName);
    });
  }
}
